//#region Components
import CustomButton from "components/CustomButton/CustomButton";
import DialogAlertAction from "components/DialogAlertAction/DialogAlertAction";
//#endregion
//#region Services
//#endregion
//#region Utils
//#endregion

const DialogErrorNotification = ({
    props, dialog
}) => {
    if (!props) return null;
    return (
        <DialogAlertAction
            variant="secondary"
            width="680px"
            widthContent="90%"
            show={dialog.value}
            toggleShow={dialog.toggle}
            title={props.title}
            contentComponent={
                typeof props.content === "string" 
                ? <p className="paragraph center">{props.content}</p>
                : props.content}>
            <CustomButton 
                width="100px"
                text="Cerrar"
                onClick={dialog.hide}/>
        </DialogAlertAction>
    );
}

export default DialogErrorNotification;